import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

export default function RankingSidebar({ items }: { items: Drama[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <i className="ri-fire-fill text-lg text-primary-500"></i>
          <h2 className="font-heading text-base font-bold text-foreground-950">热门剧集榜</h2>
        </div>
        <span className="text-xs text-foreground-500">实时热度</span>
      </div>

      <ol className="space-y-1">
        {items.map((d, i) => (
          <li key={d.id}>
            <Link
              to={`/detail/${d.id}`}
              className="group flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-100"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded font-label text-xs font-bold ${
                  i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <span className="h-12 w-9 shrink-0 overflow-hidden rounded">
                <img
                  src={d.poster}
                  alt={`${d.title} 海报`}
                  title={`${d.title} 热度榜`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {d.title}
                </span>
                <span className="mt-0.5 block truncate text-xs text-foreground-500">
                  {d.types.slice(0, 2).join(" · ")}
                </span>
              </span>
              <span className="flex items-center gap-0.5 font-label text-xs font-semibold text-accent-600">
                <i className="ri-fire-line"></i>
                {d.hot}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}